<template>
  <div class="page-container page-container full-width bg-white">
    <h1>{{ $t("bookmarksTitle") }}</h1>
    <div class="no-bookmarks" v-if="!hasBookmarks || nothingToShow">
      {{ $t('bookmarksNothingFound') }}
    </div>
    <bookmarks-actions v-if="hasBookmarks"/>
    <ul class="companies-list bookmarks-companies-list" v-if="hasBookmarks">
      <company-item :item="company" v-for="company in filter.companyBookmarks" :key="`company-${company.id}`"/>
      <shop-item :item="salespoint" v-for="salespoint in filter.salespointBookmarks" :key="`salespoint-${salespoint.id}`"/>
    </ul>
  </div>
</template>

<script>
import CompanyItem from '@/components/lists/CompanyItem.vue'
import ShopItem from '@/components/lists/ShopItem.vue'
import BookmarksActions from "@/components/BookmarksActions.vue";

export default {
  name: 'BookmarksPage',
  components: {
    BookmarksActions,
    CompanyItem,
    ShopItem
  },
  data() {
    return {
      isFiltered: false,
      filter: {
        entities: '', // nothing === all entities, no type filter
        companyBookmarks: [],
        salespointBookmarks: []
      },
      bookmarks: null
    }
  },
  metaInfo() {
    return {
      title: this.$t('bookmarksTitle') + ' | ' + 'Kärnten Card App',
      meta: [{
        property: 'og:title', content: this.$t('bookmarksTitle') + ' | ' + 'Kärnten Card App'
      }, {
        property: 'og:site_name', content: 'Kärnten Card App'
      }, {
        property: 'og:url', content: window.location.href
      }, {
        property: 'og:image', content: "https://app.kaerntencard.at/img/kc-logo.png"
      }, {
        property: 'og:description', content: ""
      }]
    }
  },
  computed: {
    hasBookmarks() {
      // console.log('hasBookmarks', this.bookmarks.length >= 1);
      return this.bookmarks.length >= 1
    },

    nothingToShow() {
      if (this.filter.isFiltered && this.filter.salespointBookmarks.length <= 0 && this.filter.companyBookmarks.length <= 0) {
        return true
      }

      return false
    }
  },
  methods: {
    filterBookmarks() {
      // console.log('filterBookmarks',this.filter);
      if (this.filter.entities === 'companies') {
        this.filter.companyBookmarks = this.bookmarks.filter(bm => bm.bmType === 'company')
        this.filter.salespointBookmarks = []
        this.filter.isFiltered = true
      }
      if (this.filter.entities === 'salespoints') {
        this.filter.companyBookmarks = []
        this.filter.salespointBookmarks = this.bookmarks.filter(bm => bm.bmType === 'salespoint')
        this.filter.isFiltered = true
      }
      if (this.filter.entities === '') {
        this.filter.companyBookmarks = this.bookmarks.filter(bm => bm.bmType === 'company')
        this.filter.salespointBookmarks = this.bookmarks.filter(bm => bm.bmType === 'salespoint')
        this.filter.isFiltered = false
      }
      // console.log('filterBookmarks finished',this.filter);
    },
    updateEntitySelection(entity) {
      this.filter.entities = entity
    }
  },
  watch: {
    'filter.entities'() {
      this.filterBookmarks()
    },
    bookmarks() {
      this.filterBookmarks()
    },
    '$store.state.season': function() {
      this.$store.dispatch('fetchCardInfos', {lang: this.$store.state.language, season: this.$store.state.season})
          .then(() => {
            this.$store.dispatch('fetchNews', {lang: this.$store.state.language, season: this.$store.state.season})
          })
          .catch(err => console.log(err))
    },
    '$store.state.language': function() {
      this.$store.dispatch('fetchCardInfos', {lang: this.$store.state.language, season: this.$store.state.season})
          .then(() => {
            this.$store.dispatch('fetchNews', {lang: this.$store.state.language, season: this.$store.state.season})
          })
          .catch(err => console.log(err))
    }
  },
  created() {
    this.bookmarks = this.$store.getters.getCurrentBookmarks
    this.$eBus.$on('update-bookmarks-entity-filter', this.updateEntitySelection);
    this.filterBookmarks()
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.85rem;
  font-weight: bold;
  text-align: center;
  margin-top: 2rem;
}

.no-bookmarks {
  display: block;
  font-weight: bold;
  width: 100%;
  max-width: rem-calc(350);
  margin: 0 auto;
  margin-top: 1rem;
  font-size: 1.15rem;
  text-align: center;
}
.bookmarks-companies-list {
  @extend .menu;
  margin-top: .5rem;

  .company-item {
    width: 100%;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  .shop-item {
    width: 100%;
  }
}
</style>
